import { render, staticRenderFns } from "./pcfilework.vue?vue&type=template&id=4ff419ba"
import script from "./pcfilework.vue?vue&type=script&lang=js"
export * from "./pcfilework.vue?vue&type=script&lang=js"
import style0 from "./pcfilework.vue?vue&type=style&index=0&id=4ff419ba&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports